import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import animateProps from 'react-animate-props';
import { Easing } from 'tweenkle';
import ProgressBar from '../ProgressBar';
import { setAbout, setMapUi, setLoadingScreen } from '../../store/ui';
import bgImg from './cp-background.jpg';
import { updateUrl } from '../../lib/url';

const Container = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  font-family: 'Lusitana', serif;
  opacity: ${({ opacity }) => opacity};
  will-change: opacity;

  background-color: #303030;
  background: linear-gradient(0, #030303, #245681);
  color: #fff;
  z-index: 1000;

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  a {
    color #fff;
  }

  &:before {
    content: "";
    background: linear-gradient(0, #030303, #245681);
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 1;
    z-index: -2;
  }
  &:after {
    content: "";
    display: block;
    background: url('${bgImg}') no-repeat center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: 70% 100%;
    z-index: -1;
    @media only screen and (max-width: 750px) {
      background-position: 87% 100%;
    }
  }
  @media only screen and (min-width: 751px) and (max-height: 720px){
    padding-bottom: 160px;
  }


`;

const ProgressWrapper = styled.div`
  position: relative;
  height: 4px;

  @media only screen and (min-width: 751px) {
    z-index: 1;
    position: fixed;
    bottom: 0px;
    height: 160px;
    left: 0;
    right: 0;
    & > div {
      bottom: 44px;
    }
    @media only screen and (min-width: 751px) and (max-height: 800px){

      &:after {
        content: "";
        display: block;
        position: absolute;
        z-index: -1;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(
          0deg,
          black 0%,
          #0000009e 50%,
          transparent 100%
        );
      }
    }
  }
`;

const Button = styled.button`

  background-color: transparent;
  display: block;
  position: relative;
  text-transform: uppercase;
  font-family: 'Source Code Pro', monospace;
  letter-spacing: 4px;
  font-size: 16px;
  border-color: white;
  /* box-shadow: 0 0 0.6em #7cffff, inset 0 0 0.3em #7cffff; */
  color: white;
  font-weight: 400;
  opacity: ${({ opacity }) => opacity};

  &:not([disabled]){
    cursor: pointer;
  }
  &#enter-map {
    border: 1px solid white;
    transition: box-shadow 100ms, text-shadow 100ms;
    will-change: auto;
    margin: 50px auto 50px;
    padding: 15px 21px 15px 22px;
    border-radius: 6px;
    text-shadow: 0 0 10px black;
    font-size: 18px;

    &:not([disabled]):hover {
      text-shadow: 0 0 10px white;
      box-shadow: 0 0 14px 0px white, inset 0 0 6px 1px white;
    }

    @media only screen and (max-width: 750px) {
      margin: 30px auto 30px;
      font-size: 16px;
    }
    @media only screen and (min-width: 751px) and (max-height: 880px) {
      margin: 30px auto 30px;
    }
  }

`;

const ButtonAbout = styled(Button)`
  background-color: transparent;
  border: 0;
  color: #fff;
  display: block;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 4px;
  margin: 0;
  opacity: ${({ opacity }) => opacity};
  padding: 8px 10px 8px 12px;
  position: fixed;
  left: 0;
  top: 0;
  text-transform: uppercase;

  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  @media only screen and (max-width: 750px) {
    font-size: 10px;
    margin: 0px 0px 0px;
    padding: 10px;
    position: relative;
  }
`;

const Title = styled.h1`

  font-size: 55px;
  letter-spacing: 0.2em;
  line-height: 1.2;
  margin: 90px 0 20px;
  text-shadow: 0 0 0.5em black, 0 0 2.2em black;

  font-weight: 100;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  @media only screen and (max-width: 750px) {
    font-size: 40px;
    margin: 28px 0 20px;
  }
  @media only screen and (max-width: 350px) {
    font-size: 30px;
    margin-top: 20px;
  }
  @media only screen and (min-width: 751px) and (max-height: 940px) {
    font-size: 50px;
    margin: 70px 0 20px;
  }
  @media only screen and (min-width: 751px) and (max-height: 800px) {
    font-size: 42px;
    margin-top: 50px;
  }
`;

const Paragraph = styled.p`
  font-weight: 100;
  letter-spacing: 1px;
  margin: 1.35em auto 1.5em;
  max-width: 580px;
  position: relative;
  text-align: center;


  font-size: 25px;
  line-height: 1.35;
  letter-spacing: 0.35px;
  text-shadow: 0 0 6px black, 0 0 76px black, 0 0 86px black;
  width: 80%;
  max-width: 600px;

  opacity: ${({ opacity }) => opacity};

  @media only screen and (max-width: 750px) {
    font-size: 18px;
    margin: 20px auto;
  }
  @media only screen and (max-width: 350px) {
    font-size: 14px;
  }
  @media only screen and (min-width: 751px) and (max-height: 850px) {
    font-size: 22px;
  }
`;

const ParagraphSmall = styled.p`
  margin: 0 auto;
  position: relative;
  text-align: center;

  font-size: 12px;
  font-family: 'Source Code Pro';
  text-transform: uppercase;
  line-height: 1.4;
  // red: #fa9393
  // cyan: #8ffaff
  color: #8ffaff;
  border-top: 1px dashed #8ffaff;
  border-bottom: 1px dashed #8ffaff;
  padding: 30px 0 32px;
  letter-spacing: 0.35px;
  max-width: 600px;
  width: 80%;

  opacity: ${({ opacity }) => opacity};

  @media only screen and (max-width: 750px) {

    line-height: 1.7;
    padding: 15px 0;
    font-size: 9.3px;
    margin: 40px auto;
  }
  @media only screen and (min-width: 751px) and (max-height: 800px) {
    padding: 15px 0 15px;
  }
`;

const LoadingInfo = styled.p`
  font-family: 'Source Code Pro', monospace;
  text-align: center;
  font-size: 12px;
  margin: 10px 10px 12px;
  text-transform: uppercase;
  color: white;
  opacity: 0.6;
  position: relative;
  letter-spacing: 0.35px;
  z-index: 1;
  letter-spacing: 1px;
  @media only screen and (min-width: 751px) {
    opacity: 1.0;
    font-size: 14px;
    position: fixed;
    bottom: 64px;
    left: 0;
    right: 0;
    z-index: 2;
  }

`;

const getLoadingText = (progress) => {
  if (progress < 4) {
    return 'Drawing coastlines...';
  }

  if (progress < 33) {
    return 'Melting ice caps...';
  }

  if (progress < 66) {
    return 'Loading street view...';
  }

  if (progress < 100) {
    return 'Loading map...';
  }

  return 'Ready.';
};

const LoadingScreen = ({
  isLoaded,
  opacity,
  progress,
  showAbout,
  hideLoadingScreen,
}) => {
  const buttonOpacity = isLoaded ? 1 : 0.35;
  const buttonDisabled = !isLoaded;

  if (opacity === 0.0) {
    return null;
  }

  return (
    <Container opacity={opacity}>
      <ButtonAbout
        id="show-about"
        aria-label="Show about text"
        onClick={showAbout}
      >
        ABOUT
      </ButtonAbout>
      <Title>
        Coastline
        <br />
        Paradox
      </Title>

      <LoadingInfo>{getLoadingText(progress)}</LoadingInfo>

      <ProgressWrapper>
        <ProgressBar stayVisible />
      </ProgressWrapper>

      <Button
        id="enter-map"
        aria-label="Enter map"
        opacity={buttonOpacity}
        disabled={buttonDisabled}
        onClick={hideLoadingScreen}
      >
        Enter Map
      </Button>

      <Paragraph opacity={1.0}>
        Coastline Paradox is a map & Street View experiment exploring the sea
        level rise caused by the climate crisis.
      </Paragraph>

      <Paragraph opacity={1.0}>
        Explore the predicted sea level rise in locations globally between 2000
        and 2300. Adjust the timeline to see how some areas will be affected by
        the sea level rise and long press to reveal the amount of affected
        population. Click hotspots to enter the street view.
      </Paragraph>

      <ParagraphSmall opacity={1.0}>
        This experimental artwork is by Pekka Niittyvirta and Timo Aho in
        collaboration with Google Arts and Culture using data from
        {' '}
        <a
          href="https://go.climatecentral.org/coastaldem/"
          target="_BLANK"
          rel="noopener noreferrer"
        >
          Climate Central
        </a>
        {' '}
        and the
        {' '}
        <a
          href="https://www.ipcc.ch/srocc/download/"
          target="_BLANK"
          rel="noopener noreferrer"
        >
          IPCC
        </a>
        .
      </ParagraphSmall>
    </Container>
  );
};

LoadingScreen.propTypes = {
  hideLoadingScreen: PropTypes.func.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  opacity: PropTypes.number,
  progress: PropTypes.number.isRequired,
  showAbout: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types,react/no-unused-prop-types
  animatedProps: PropTypes.object,
};

LoadingScreen.defaultProps = {
  opacity: 1.0,
  animatedProps: {
    opacity: {
      ease: Easing.Quad.InOut,
      delay: 0,
      duration: 600,
    },
  },
};

export default connect(
    ({ map, panorama, ui }) => ({
      opacity: ui.isLoadingScreen ? 1.0 : 0.0,
      progress: ui.isMapUi ? map.progress : panorama.progress,
      isLoaded: (ui.isMapUi ? map.progress : panorama.progress) >= 100.0,
    }),

    (dispatch) => ({
      showAbout: () => dispatch(setAbout(true)),
      updateMapUi: (isMapUi) => dispatch(setMapUi(isMapUi)),
      hideLoadingScreen: () => dispatch((d, getState) => {
        dispatch(setLoadingScreen(false));
        updateUrl(getState());
      }),
    }),
)(animateProps(LoadingScreen, LoadingScreen.defaultProps));
